import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal, AutoComplete } from "antd";
import { toast } from "react-toastify";
import "./map.css";
import { Card, Col, Row, Statistic } from "antd";
import moment from "moment";

import GmapMultiple from "./GmapMultiple";

const F1MAP = (props) => {
  const frmRef = useRef({});
  const [data, setData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [farmerId, setFarmerId] = useState();
  const [farmerData, setFarmerData] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");

  const [plotDataList, setplotDataList] = useState([]);

  const [cropDataList, setcropDataList] = useState([]);
  const [cropList, setcropList] = useState([]);

  const [cropId, setCropId] = useState(0);

  const [areaData, setAreaData] = useState([]);
  const [areaId, setAreaId] = useState(0);

  const [varietyData, setVarietyData] = useState([]);
  const [allVarietyData, setAllVarietyData] = useState([]);
  const [varietyId, setVarietyId] = useState(0);

  const [regionId, setRegionId] = useState(0);
  const [regionData, setRegionData] = useState([]);

  const [totalLand, settotalLand] = useState(0);
  const [cropsCount, setcropsCount] = useState(0);

  const [coordinate, setcoordinate] = useState([]);
  const [marketCoordinate, setMarketCoordinate] = useState([]);
  const [plotCoordinateList, setPlotCoordinateList] = useState([]);

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRegion } = useHttp();

  const regionList = () => {
    getRegion(
      {
        url: `/api/farmerRegionForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("regionlist", data.regionlist);

        if (data && data.regionlist) {
          setRegionData(data.regionlist);
        }
      }
    );
  };
  useEffect(() => {
    getEmployeeData();
    regionList();
  }, [getRegion]);

  const { sendRequest: getCropVarietyData } = useHttp();
  useEffect(() => {
    getCropVarietyData(
      {
        url: `/api/farmerCropVarietyForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log(data);

        setcropList(data.cropList);
        setAllVarietyData(data.varietylist);
      }
    );
  }, [getCropVarietyData]);

  const { sendRequest: getArea } = useHttp();

  const areaList = () => {
    getArea(
      {
        url: `/api/farmerAreaForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        if (data) {
          console.log("area", data);
          setAreaData(data.arealist);
        }
      }
    );
  };

  useEffect(() => {
    areaList();
  }, []);

  const { sendRequest: getEmp } = useHttp();

  const getEmployeeData = (id) => {
    getEmp(
      {
        url: `/api/farmerExecutiveForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log(data);

        setEmployeeData(data.executivelist);
      }
    );
  };

  const { sendRequest: getFarmerList } = useHttp();
  useEffect(() => {
    getFarmerList(
      {
        url: `/api/farmerListForSelection/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.table(data);
        setFarmerData(data);
      }
    );
  }, [getFarmerList]);

  const { sendRequest: getData } = useHttp();

  const fillFarmerDetails = () => {
    var urlfilter = "";

    urlfilter =
      urlfilter + `&fromDate=${moment(selectedFromDate).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter + `&toDate=${moment(selectedToDate).format("DD/MM/YYYY")}`;

    if (cropId > 0) {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }
    if (varietyId > 0) {
      urlfilter = urlfilter + `&varietyId=${varietyId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (areaId > 0) {
      urlfilter = urlfilter + `&areaId=${areaId}`;
    }

    if (farmerId) {
      urlfilter = urlfilter + `&farmerId=${farmerId}`;
    }

    getPlot(
      {
        url: `/api/farmerOneDashBoardSummary/?userId=${localStorage.getItem(
          "id"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (res) => {
        console.log("data", res);
        setData(res);
      }
    );
  };

  const handleCropChange = (e) => {
    const selectedCropId = e.target.value;
    setCropId(selectedCropId);

    // Filter varieties based on selected crop
    const filteredVarieties =
      allVarietyData &&
      allVarietyData.filter(
        (variety) => variety.cropMasterId === parseInt(selectedCropId)
      );

    setVarietyData(filteredVarieties);
  };

  const { sendRequest: getPlot } = useHttp();

  const getPlotData = () => {
    var markerList = [];
    var PlotCoordinatetempList = [];

    setMarketCoordinate(markerList);
    setPlotCoordinateList(PlotCoordinatetempList);

    var urlfilter = "";
    urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
    urlfilter = urlfilter + `&toDate=${selectedToDate}`;

    if (cropId > 0) {
      urlfilter = urlfilter + `&cropId=${cropId}`;
    }
    if (varietyId > 0) {
      urlfilter = urlfilter + `&varietyId=${varietyId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (areaId > 0) {
      urlfilter = urlfilter + `&areaId=${areaId}`;
    }

    if (farmerId) {
      urlfilter = urlfilter + `&farmerId=${farmerId}`;
    }

    getPlot(
      {
        url: `/api/FillFarmerPlotDetailForMap/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        console.log(data);

        var filterplot = data.plot;
        var filterCrop = data.crop;

        setplotDataList(filterplot);
        setcropDataList(filterCrop);

        var polId = 1;

        try {
          filterplot.forEach((item) => {
            var coordinates = {};

            if (item && item.plotCoordinates.length > 0) {
              var plotCorodinate = [];

              if (item.plotCoordinates?.includes('"')) {
                plotCorodinate = JSON.parse(item.plotCoordinates);
              } else {
                plotCorodinate = item.plotCoordinates;
              }

              coordinates = {
                lat: plotCorodinate[0].latitude,
                lng: plotCorodinate[0].longitude,
              };

              var cropselectItem = filterCrop.filter(
                (eitem) => eitem.plotId == item.plotId
              );

              var colorcode = "Red";
              var croplist = "";

              if (cropselectItem && cropselectItem.length > 0) {
                var cropItem = cropselectItem[0];

                colorcode = cropItem.mapColor;

                croplist = cropItem.farmerName + " (" + cropItem.cropName + ")";
              }

              markerList = markerList.concat({
                lat: plotCorodinate[0].latitude,
                lng: plotCorodinate[0].longitude,
                tittle: item.farmerName + croplist,
                markeyType: colorcode,
              });

              var plotNewCoordinates = [];

              plotCorodinate?.map((item) => {
                plotNewCoordinates = plotNewCoordinates.concat({
                  lat: item.latitude,
                  lng: item.longitude,
                });
              });

              PlotCoordinatetempList = PlotCoordinatetempList.concat({
                plotCorodinate: plotNewCoordinates,
                colorCode: colorcode,
                id: "ply" + polId,
              });
            }

            polId = polId + 1;
          });
        } catch (e) {
          console.log("Error", e);
        }

        if (markerList.length > 0) {
          setMarketCoordinate([...markerList]);
        }

        //setMarketCoordinate([...markerList]);
        

        if (PlotCoordinatetempList.length > 0) {
          setcoordinate([...PlotCoordinatetempList[0].plotCorodinate]);
          setPlotCoordinateList([...PlotCoordinatetempList]);
        }
        else {
       
          setPlotCoordinateList([]);
          setcoordinate([]);
        }
      }
    );
  };

  useEffect(() => {
    getPlotData();
    fillFarmerDetails();
  }, []);

  const handleSearch = (value) => {
    setFarmerNumber(value);

    const farmerNo = value?.split(" -")[0] || "";

    const selectedFarmer = farmerData.find(
      (item) => item.farmerNo === farmerNo
    );

    if (selectedFarmer) {
      setFarmerId(selectedFarmer.farmerId || 0);
    }

    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) =>
        (item.farmerNo + item.farmerName)
          ?.toLowerCase()
          .includes(farmerNumber?.toLowerCase())
      )
      .map((item) => ({
        value: `${item.farmerNo} -${item.farmerName}`,
        label: `${item.farmerNo} -${item.farmerName}`,
      }));

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <br />
            <label className="card-title">
              {" "}
              &nbsp; &nbsp;Detailed Field Analytics{" "}
            </label>{" "}
          </div>

          <div className="col-3"> </div>
          <div className="col-3 text-right"></div>
        </div>
        <br />

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              {" "}
                              <label htmlFor={"from_date"}>{"From Date"}</label>
                              <input
                                type={"date"}
                                id={"date"}
                                required
                                // ref={(el) => (frmRef.current["pdate"] = el)}
                                className="form-control"
                                max={currentDate}
                                value={selectedFromDate}
                                onChange={handleFDateChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor={"to_date"}>{"To Date"}</label>

                              <input
                                type={"date"}
                                id={"date"}
                                required
                                // ref={(el) => (frmRef.current["pdate"] = el)}
                                className="form-control"
                                max={currentDate}
                                value={selectedToDate}
                                onChange={handleTDateChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor={"crop"} className="mx-2">
                                {"Crop"}
                              </label>
                              <select
                                id="cropId"
                                className="form-control"
                                ref={(el) => (frmRef.current["crop"] = el)}
                                onChange={handleCropChange}
                              >
                                <option value="0">Select Crop</option>
                                {cropList &&
                                  cropList.map((x) => (
                                    <option
                                      key={x.cropMasterId}
                                      value={x.cropMasterId}
                                    >
                                      {x.cropName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label htmlFor={"variety"} className="mx-2">
                              {"Variety"}
                            </label>
                            <div className="form-group">
                              <select id="varietyId" className="form-control">
                                <option value="">Select Variety</option>
                                {varietyData.map((variety) => (
                                  <option
                                    key={variety.varietyId}
                                    value={variety.varietyId}
                                  >
                                    {variety.varietyName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor={"variety"} className="mx-2">
                              {"Region"}
                            </label>
                            <div className="form-group">
                              <select
                                id="regionId"
                                className="form-control"
                                ref={(el) => (frmRef.current["regionId"] = el)}
                                value={regionId}
                                onChange={(e) => {
                                  setRegionId(e.target.value);
                                }}
                              >
                                <option value="0">Select Region</option>
                                {regionData &&
                                  regionData.map((x) => (
                                    <option
                                      key={x.regionId}
                                      user-id={x.regionId}
                                      value={x.regionId}
                                    >
                                      {x.regionName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label htmlFor={"area"} className="mx-2">
                              {"Area"}
                            </label>
                            <div className="form-group">
                              <select
                                id="areaId"
                                className="form-control"
                                ref={(el) => (frmRef.current["areaId"] = el)}
                                value={areaId}
                                onChange={(e) => {
                                  setAreaId(e.target.value);
                                }}
                              >
                                <option value="0">Select Area</option>
                                {areaData &&
                                  areaData.map((x) => (
                                    <option
                                      key={x.areaId}
                                      farmer-id={x.areaId}
                                      value={x.areaId}
                                    >
                                      {x.areaName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label htmlFor={"Executive"} className="mx-2">
                              {"Executive"}
                            </label>
                            <div className="form-group">
                              <select
                                id="emp_id"
                                className="form-control"
                                ref={(el) => (frmRef.current["emp_id"] = el)}
                                value={employeeId}
                                onChange={(e) => {
                                  setEmployeeId(e.target.value);
                                }}
                              >
                                <option value="0">Select Executive</option>
                                {employeeData &&
                                  employeeData.map((x) => (
                                    <option
                                      key={x.user}
                                      user-id={x.fieldExecutiveId}
                                      value={x.fieldExecutiveId}
                                    >
                                      {x.fieldExecutiveName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="farmer_number">Farmer Number</label>
                            <AutoComplete
                              className="form-control ant-select-selector"
                              value={farmerNumber}
                              options={filteredOptions}
                              placeholder="Farmer Number"
                              onChange={handleSearch}
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mx-3 my-4">
                              <button
                                className="form-control btn btn-sm btn-primary"
                                onClick={() => {
                                  getPlotData();
                                  fillFarmerDetails();
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-2"></div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-3">
                            <div className="info-box-map small-box">
                              <span className="info-box-icon-map red-bg">
                                &nbsp;
                              </span>
                              <div className="info-box-content-map">
                                <span className="info-box-text small-text">
                                  Contract
                                </span>
                                <span className="info-box-text small-text">
                                  Pending
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="info-box-map small-box">
                              <span className="info-box-icon-map cyan-bg">
                                &nbsp;
                              </span>
                              <div className="info-box-content-map">
                                <span className="info-box-text small-text">
                                  Contract
                                </span>
                                <span className="info-box-text small-text">
                                  Completed
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div className="info-box-map small-box">
                              <span className="info-box-icon-map yellow-bg">
                                &nbsp;
                              </span>
                              <div className="info-box-content-map">
                                <span className="info-box-text small-text">
                                  Procurement
                                </span>
                                <span className="info-box-text small-text">
                                  Pending
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="info-box-map small-box">
                              <span className="info-box-icon-map green-bg">
                                &nbsp;
                              </span>
                              <div className="info-box-content-map">
                                <span className="info-box-text small-text">
                                  Procurement
                                </span>
                                <span className="info-box-text small-text">
                                  Completed
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            style={{
                              width: "420px",
                              height: "400px",
                              margin: "2px",
                            }}
                          >
                            <GmapMultiple
                              coordinate={coordinate}
                              marketCoordinate={marketCoordinate}
                              plotCoordinateList={plotCoordinateList}
                              mapzoom={17}
                            />
                          </div>
                        </div>
                        <br />
                        <Row gutter={10}>
                          <Col span={5}>
                            <Card bordered={true}>
                              <Statistic
                                title="Farmers"
                                value={data?.farmerCount}
                                valueStyle={{ color: "#3f8600" }}
                              />
                            </Card>
                          </Col>
                          <Col span={7}>
                            <Card bordered={true}>
                              <Statistic
                                title="Area Covered"
                                value={
                                  (data?.totallandArea?.totalLand ?? 0) +
                                  " " +
                                  (data?.totallandArea?.landUnit ?? "")
                                }
                                valueStyle={{ color: "#cf1322" }}
                              />
                            </Card>
                          </Col>

                          <Col span={5}>
                            <Card bordered={true}>
                              <Statistic
                                title="Crops"
                                value={data?.cropCount}
                                valueStyle={{ color: "#3f8600" }}
                              />
                            </Card>
                          </Col>
                          <Col span={5}>
                            <Card bordered={true}>
                              <Statistic
                                title="Variety"
                                value={data?.varietyCount}
                                valueStyle={{ color: "#3f8600" }}
                              />
                            </Card>
                          </Col>
                        </Row>
                        &nbsp;
                        <div className="card">
                          <div className="card-header border-transparent">
                            <h3 className="card-title">Total Harvest</h3>
                            <div className="card-tools">
                              <button
                                type="button"
                                className="btn btn-tool"
                                data-card-widget="collapse"
                              >
                                <i className="fas fa-minus" />
                              </button>
                            </div>
                          </div>

                          <div className="card-body p-0">
                            <div className="table-responsive">
                              <table className="table m-0  text-center">
                                <thead>
                                  <tr>
                                    <th>Crop Name</th>
                                    <th>Estimated Yield</th>
                                    <th>Harvested Qty</th>
                                    <th>Unit</th>
                                    <th>Amount</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {data.totalHarvest &&
                                    data.totalHarvest.map((x, i) => (
                                      <tr key={i}>
                                        <td>{x.cropName}</td>
                                        <td>{x.estimateYieldInKg}</td>
                                        <td>{x.totalQuantity}</td>

                                        <td>{x.unitAbbreviation}</td>
                                        <td>{x.totalAmount}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default F1MAP;
